import { DocumentModel } from './document.model';
import { DependentModel } from './dependent.model';
import { CompanyModel } from './company.model';
import { CreditCardModel } from './creditCard.model';

export class ResponsibleModel {
  id: string;
  name: string;
  birth: Date;
  email: string;
  document: DocumentModel;
  documentType: number;
  documentDescription: string;
  company: CompanyModel;
  dependents: DependentModel;
  creditCards: CreditCardModel[];

  constructor() {
    this.birth = new Date();
    this.document = new DocumentModel();
    this.company = new CompanyModel();
    this.dependents = new DependentModel();
    this.creditCards = new Array<CreditCardModel>();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/responsible.model.ts